import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageCircle, Share2, Globe } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0F0F12] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <img src="/ayronn-logo.png" alt="AYRONN Funding" className="h-[90px] sm:h-[100px] md:h-[119px] w-auto" />
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Trade Bigger. Earn Smarter.
            </p>
            <div className="flex items-center gap-2 mt-3">
              <img src="/exness-logo.png" alt="Exness" className="h-4 w-auto opacity-60" />
              <span className="text-zinc-500 text-xs">Powered by Exness</span>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-zinc-400 hover:text-white transition-colors text-sm">Home</Link></li>
              <li><Link to="/pricing" className="text-zinc-400 hover:text-white transition-colors text-sm">Pricing</Link></li>
              <li><Link to="/terms" className="text-zinc-400 hover:text-white transition-colors text-sm">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="text-zinc-400 hover:text-white transition-colors text-sm">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-zinc-400 hover:text-white transition-colors text-sm">Blog</Link></li>
              <li><Link to="/best-prop-firm-for-beginners" className="text-zinc-400 hover:text-white transition-colors text-sm">Best Prop Firm for Beginners</Link></li>
              <li><Link to="/instant-funding-prop-firm" className="text-zinc-400 hover:text-white transition-colors text-sm">Instant Funding</Link></li>
              <li><Link to="/cheapest-prop-firm" className="text-zinc-400 hover:text-white transition-colors text-sm">Cheapest Prop Firm</Link></li>
              <li><Link to="/prop-firm-india" className="text-zinc-400 hover:text-white transition-colors text-sm">Prop Firm India</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/rules" className="text-zinc-400 hover:text-white transition-colors text-sm font-semibold" data-testid="footer-rules-link">Trading Rules & Conditions</Link></li>
              <li><Link to="/terms" className="text-zinc-400 hover:text-white transition-colors text-sm">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="text-zinc-400 hover:text-white transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/risk-disclosure" className="text-zinc-400 hover:text-white transition-colors text-sm">Risk Disclosure</Link></li>
              <li><Link to="/refund-policy" className="text-zinc-400 hover:text-white transition-colors text-sm">Refund Policy</Link></li>
              <li><Link to="/disclaimer" className="text-zinc-400 hover:text-white transition-colors text-sm">Disclaimer</Link></li>
              <li><a href="mailto:ayronnsupport@gmail.com" className="text-zinc-400 hover:text-white transition-colors text-sm">Contact Us</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Follow Us</h4>
            <div className="flex items-center space-x-4">
              <a href="#" className="text-zinc-400 hover:text-brand-primary transition-colors" aria-label="Twitter"><MessageCircle className="w-5 h-5" /></a>
              <a href="#" className="text-zinc-400 hover:text-brand-primary transition-colors" aria-label="Social"><Share2 className="w-5 h-5" /></a>
              <a href="#" className="text-zinc-400 hover:text-brand-primary transition-colors" aria-label="Website"><Globe className="w-5 h-5" /></a>
              <a href="mailto:ayronnsupport@gmail.com" className="text-zinc-400 hover:text-brand-primary transition-colors" aria-label="Email"><Mail className="w-5 h-5" /></a>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-10 pt-6 border-t border-white/5 space-y-3">
          <p className="text-zinc-600 text-xs leading-relaxed max-w-4xl">
            All trading activities are simulated. AYRONN Funding provides evaluation services for skilled traders, not investment services. Performance-based rewards are subject to evaluation criteria and trading rules. Past performance does not guarantee future results. Trading involves substantial risk of loss.
          </p>
          <p className="text-zinc-500 text-xs leading-relaxed max-w-4xl" data-testid="footer-marketing-disclaimer">
            <span className="text-brand-gold font-semibold">Marketing &amp; Demo Notice:</span> All data displayed on this website — including payout proofs, trader testimonials, leaderboards, live stats, and popup notifications — is presented for marketing, illustrative and demonstrational purposes only. Individual results vary and are not guaranteed. Any figures shown should not be relied upon as an indicator of your own potential performance or earnings.
          </p>
        </div>

        <div className="mt-6 pt-4 border-t border-white/5 text-center">
          <p className="text-zinc-600 text-xs">
            &copy; {new Date().getFullYear()} AYRONN Funding. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
